import Vue from 'vue';

import * as VueGoogleMaps from 'vue2-google-maps';
import App from './App.vue';

window.$ = require('jquery');

Vue.config.productionTip = false;

Vue.use(VueGoogleMaps, {
	load: {
		key: 'AIzaSyBUK35OvSdIT1ZzNru2pxcD7_zxBhzYmy8',
	},
});

new Vue({
	render: h => h(App),
}).$mount('#app');
